import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from "./handlers";

declare const window: any;

export const vatValidationApi = createApi({
    reducerPath: 'vatValidation',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.VAT_VALIDATION ?? 'https://vatvalidation.cimpress.io/v1/vatvalidation',
        prepareHeaders: (headers) => {
            headers.set('Content-Type', 'application/json')
            return headers
        },
    }),
    tagTypes: ['Product'],
    endpoints: (builder) => ({
        validateVat: builder.mutation({
            query: ({ authorizationToken, ...data }) => ({
                url: '',
                method: 'POST',
                body: data,
                headers: { Authorization: authorizationToken }
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({ operation: 'validateVat', err: JSON.stringify(error), errMsg: 'Error: while vat validation', api: `${window.Config.VAT_VALIDATION}`}));
                }
            }
        })
    }),
})

export const { useValidateVatMutation } = vatValidationApi;